export default {
  data() {
    return {
      requestTimout: null,
    };
  },
  methods: {
    requestForResults(functionName, typeEvent = null, index = null) {
      clearTimeout(this.requestTimout);
      this.requestTimout = setTimeout(() => {
        'trying tor run method --', typeof typeEvent, index;
        if (typeEvent !== null && index !== null)
          this[functionName](typeEvent, index);
        else if (typeEvent) this[functionName](typeEvent);
        else this[functionName]();
      }, 800);
    },
  },
};
